import {
  Panel,
  PanelType,
} from "@fluentui/react";
import React from "react";
import { ButtonFormPanel } from "./buttonForm";
import { IpanelGeneric } from "../../Interfaces/IPanel";
import HeaderGeneric from "./headerGeneric";
import HeaderTable from "./HeaderTable";

export const PanelGenerico = (props: IpanelGeneric) => {
  const onRenderHeader = React.useCallback(
    () =>
      props.enabledHeader ? (
        <div className="ms-Grid-col ms-sm12 ms-lg11">
          <HeaderGeneric
            enabledicon={props.enabledIconHeader}
            iconHeaderName={props.iconHeaderName}
            title={props.HeaderTitlesText?.title}
            subTitle={props.HeaderTitlesText?.subTitle}
            subTitle2={props.HeaderTitlesText?.subTitle2}
            sizeTitles={{ first: 120, second: 122, iconSize: 38 }}
          ></HeaderGeneric>
          {/* <HeaderTable hidenIcon={false} iconName={props.iconHeaderName} title={props.HeaderTitlesText?.title!} subTitle={props.HeaderTitlesText?.subTitle}></HeaderTable> */}
        </div>
      ) : (
        <></>
      ),
    [props.isOpen]
  );
  const onRendeFooter = React.useCallback(
    () =>
      !props.enabledFooter ? (
        <div style={{ padding: "1em" }}>
          <ButtonFormPanel
            back={props.cancelar}
            register={props.registrar}
            textRegister={props.textRegister}
            textCancel={props.textCancel}
            disabledRegister={props.disabledRegister}
          ></ButtonFormPanel>
        </div>
      ) : (
        <></>
      ),
    [props.isOpen, props.onDismiss, props.objectRenderBodyHelp,props.registrar]
  );



  
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      type={props.panelType ?? PanelType.medium}
      closeButtonAriaLabel="Close"
      isLightDismiss={true}
      onRenderHeader={props.onRenderHeader}
      onRenderFooter={props.enabledFooter ? props.onRendeFooter : onRendeFooter}
      onRenderBody={props.onRenderBody}
      isFooterAtBottom={true}
    >
      {props.children}
    </Panel>
  );
};